const getters = {
    sidebar: state => state.app.sidebar,
    api_access_token: state => state.admin.api_access_token,
    admin_name: state => state.admin.name,
    admin_mobile: state => state.admin.mobile,
    admin_permissions: state => state.admin.permissions,
    permission_routes: state => state.permission.routes
}
export default getters
